import React from 'react';
import {Button, Descriptions, Modal, Typography} from 'antd';
import {useTranslation} from 'react-i18next';

export default function TextAssetFieldDetails({field, definition, onClose}) {
    const {t} = useTranslation();
    if (!field) return null;
    const attrs = definition || field;
    const free = attrs.free !== false;
    const choices = attrs.custom_meta_values_attributes;
    return <Modal title={t('custom-field-details', 'Custom field details')} open onCancel={onClose}
        footer={<Button onClick={onClose}>{t('close', 'Close')}</Button>}>
        <Descriptions bordered size="small" column={1}>
            <Descriptions.Item label={t('name', 'Name')}>{field.name}</Descriptions.Item>
            <Descriptions.Item label={t('description', 'Description')}>{attrs.description || '—'}</Descriptions.Item>
            <Descriptions.Item label={t('value-type', 'Value type')}>{attrs.value_type}</Descriptions.Item>
            <Descriptions.Item label={t('required-in-this-type', 'Required in this type')}>{field.required ? t('yes', 'Yes') : t('no', 'No')}</Descriptions.Item>
            <Descriptions.Item label={t('multiple-values', 'Multiple values')}>{attrs.multi ? t('yes', 'Yes') : t('no', 'No')}</Descriptions.Item>
            <Descriptions.Item label={t('values', 'Values')}>{free ? t('free-values', 'Free values') : t('controlled-values', 'Controlled values')}</Descriptions.Item>
            {!free && <Descriptions.Item label={t('allow-new-controlled-values', 'Allow new controlled values during import')}>{attrs.enable_controlled_vocab_creation !== false ? t('yes', 'Yes') : t('no', 'No')}</Descriptions.Item>}
            {!free && <Descriptions.Item label={t('controlled-choices', 'Controlled choices')}>
                {choices?.length ? <ul style={{margin: 0, paddingInlineStart: 20, maxHeight: 240, overflow: 'auto'}}>{choices.map((choice, index) =>
                    <li key={choice.id ?? index}>{String(choice.text ?? choice.date ?? choice.number ?? '—')}</li>)}</ul> :
                    <Typography.Text type="secondary">{choices ? t('no-controlled-choices', 'No choices defined') : t('choices-after-save', 'Choices will be available after saving this field')}</Typography.Text>}
            </Descriptions.Item>}
        </Descriptions>
    </Modal>;
}
